import DeleteIcon from "@mui/icons-material/Delete";

import PfaActionMenuItem from "./PfaActionMenuItem";

const PfaDeleteAction = ({ file }) => {
  return <PfaActionMenuItem file={file} Icon={DeleteIcon} label="Delete" />;
};

export default PfaDeleteAction;
